import { DiffViewer } from '@/components/monaco/diffViewer/diffViewer';
import type { StoryDeclaration } from '@/components/sandbox/sandboxMapping';

export const diffViewerStory = {
  variants: {
    State: () => (
      <DiffViewer
        after={{
          ended: false,
          createdAt: '2025-10-06T20:08:29.164Z',
          entity: 'AXA SWITZERLAND /CH',
          entityLabel: 'winterhur',
          ffLines: [
            {
              accountType: 'Définitif / réel',
              amountToBePaid: -65_685,
              amountToBePaidTargetCurrency: -65_685,
              beneficiaryNameLong: 'AXA VERSICHERUNGEN AG',
              currency: 'CHF',
              currentBalance: -65_685,
              initialBalance: -65_685,
              periodEnd: '2019-12-31T00:00:00Z',
              ppStatus: 'Ongoing',
              programName: 'SGR CH/ ACCIDENTS',
              reference: '539144',
              scope: 'No',
              sectionName: 'CHF-XL SOUS ACCIDENTS DU TRAV',
              sectionNb: '1',
              status: 'Valid',
              thirdPartyBeneficiaryBUID: '4325',
              treatyName: '1990-ITP 316A - XL SOUS ACCIDENTS DU TRAV',
              treatyNb: '1990-381563',
              uwy: '1990'
            },
            {
              accountType: 'Définitif / réel',
              amountToBePaid: -10_464,
              amountToBePaidTargetCurrency: -10_464,
              beneficiaryNameLong: 'AXA VERSICHERUNGEN AG',
              currency: 'CHF',
              currentBalance: -10_464,
              initialBalance: -10_464,
              periodEnd: '2019-12-31T00:00:00Z',
              ppStatus: 'Ongoing',
              programName: 'SGR CH/ ACCIDENTS',
              reference: '539160',
              scope: 'No',
              sectionName: 'CHF-XL SOUS ACCIDENTS DU TRAV',
              sectionNb: '1',
              status: 'Valid',
              thirdPartyBeneficiaryBUID: '4325',
              treatyName: '1992-ITP 316A - XL SOUS ACCIDENTS DU TRAV',
              treatyNb: '1992-381985',
              uwy: '1992'
            }
          ],
          ffLinesOriginal: [
            {
              accountType: 'Définitif / réel',
              amountToBePaid: -65_685,
              amountToBePaidTargetCurrency: -65_685,
              beneficiaryNameLong: 'AXA VERSICHERUNGEN AG',
              currency: 'CHF',
              currentBalance: -65_685,
              initialBalance: -65_685,
              periodEnd: '2019-12-31T00:00:00Z',
              ppStatus: 'Ongoing',
              programName: 'SGR CH/ ACCIDENTS',
              reference: '539144',
              scope: 'No',
              sectionName: 'CHF-XL SOUS ACCIDENTS DU TRAV',
              sectionNb: '1',
              status: 'Valid',
              thirdPartyBeneficiaryBUID: '4325',
              treatyName: '1990-ITP 316A - XL SOUS ACCIDENTS DU TRAV',
              treatyNb: '1990-381563',
              uwy: '1990'
            }
          ],
          ffTraceId: '30309bc2-acaa-40bb-a4a8-c5bcb7c10592',
          paymentCurrency: 'EUR',
          rates: [
            {
              id: 'CHF-EUR',
              rate: 1,
              sourceCurrency: 'CHF',
              targetCurrency: 'EUR'
            }
          ],
          scopeValidated: false,
          status: {
            progress: 3.0e-1,
            status: 'Scoping in progress'
          },
          terminated: false,
          totalAmount: 0,
          utils: {
            withMultiCurrencies: true
          }
        }}
        before={{
          createdAt: '2025-10-06T20:08:35.847Z',
          ended: false,
          entity: 'AXA SWITZERLAND /CH',
          entityLabel: 'winterhur',
          ffLines: [
            {
              accountType: 'Définitif / réel',
              amountToBePaid: -65_685,
              amountToBePaidTargetCurrency: -65_685,
              beneficiaryNameLong: 'AXA VERSICHERUNGEN AG',
              currency: 'CHF',
              currentBalance: -65_685,
              initialBalance: -65_685,
              periodEnd: '2019-12-31T00:00:00Z',
              ppStatus: 'Ongoing',
              programName: 'SGR CH/ ACCIDENTS',
              reference: '539144',
              scope: 'No',
              sectionName: 'CHF-XL SOUS ACCIDENTS DU TRAV',
              sectionNb: '1',
              status: 'Valid',
              thirdPartyBeneficiaryBUID: '4325',
              treatyName: '1990-ITP 316A - XL SOUS ACCIDENTS DU TRAV',
              treatyNb: '1990-381563',
              uwy: '1990'
            },
            {
              accountType: 'Définitif / réel',
              amountToBePaid: -10_464,
              amountToBePaidTargetCurrency: -10_464,
              beneficiaryNameLong: 'AXA VERSICHERUNGEN AG',
              currency: 'CHF',
              currentBalance: -10_464,
              initialBalance: -10_464,
              periodEnd: '2019-12-31T00:00:00Z',
              ppStatus: 'Ongoing',
              programName: 'SGR CH/ ACCIDENTS',
              reference: '539160',
              scope: 'No',
              sectionName: 'CHF-XL SOUS ACCIDENTS DU TRAV',
              sectionNb: '1',
              status: 'Valid',
              thirdPartyBeneficiaryBUID: '4325',
              treatyName: '1992-ITP 316A - XL SOUS ACCIDENTS DU TRAV',
              treatyNb: '1992-381985',
              uwy: '1992'
            }
          ],
          ffLinesOriginal: [
            {
              accountType: 'Définitif / réel',
              amountToBePaid: -65_685,
              amountToBePaidTargetCurrency: -65_685,
              beneficiaryNameLong: 'AXA VERSICHERUNGEN AG',
              currency: 'CHF',
              currentBalance: -65_685,
              initialBalance: -65_685,
              periodEnd: '2019-12-31T00:00:00Z',
              ppStatus: 'Ongoing',
              programName: 'SGR CH/ ACCIDENTS',
              reference: '539144',
              scope: 'No',
              sectionName: 'CHF-XL SOUS ACCIDENTS DU TRAV',
              sectionNb: '1',
              status: 'Valid',
              thirdPartyBeneficiaryBUID: '4325',
              treatyName: '1990-ITP 316A - XL SOUS ACCIDENTS DU TRAV',
              treatyNb: '1990-381563',
              uwy: '1990'
            },
            {
              accountType: 'Définitif / réel',
              amountToBePaid: -10_464,
              amountToBePaidTargetCurrency: -10_464,
              beneficiaryNameLong: 'AXA VERSICHERUNGEN AG',
              currency: 'CHF',
              currentBalance: -10_464,
              initialBalance: -10_464,
              periodEnd: '2019-12-31T00:00:00Z',
              ppStatus: 'Ongoing',
              programName: 'SGR CH/ ACCIDENTS',
              reference: '539160',
              scope: 'No',
              sectionName: 'CHF-XL SOUS ACCIDENTS DU TRAV',
              sectionNb: '1',
              status: 'Valid',
              thirdPartyBeneficiaryBUID: '4325',
              treatyName: '1992-ITP 316A - XL SOUS ACCIDENTS DU TRAV',
              treatyNb: '1992-381985',
              uwy: '1992'
            }
          ],
          ffTraceId: '30309bc2-acaa-40bb-a4a8-c5bcb7c10592',
          paymentCurrency: 'EUR',
          rates: [
            {
              id: 'CHF-EUR',
              rate: 1,
              sourceCurrency: 'CHF',
              targetCurrency: 'EUR'
            }
          ],
          scopeValidated: false,
          status: {
            progress: 3.0e-1,
            status: 'Scoping in progress'
          },
          terminated: false,
          totalAmount: 0
        }}
        className="h-full w-2/3"
      />
    ),
    Json: () => (
      <DiffViewer
        after={{
          age: 30,
          email: 'jane.doe@example.com',
          address: {
            street: '123 Main St',
            city: 'Anytown',
            state: 'CA',
            zip: '12345'
          }
        }}
        before={{
          name: 'John Doe',
          age: 30,
          email: 'john.doe@example.com'
        }}
        className="h-7/10 w-2/3"
        height={360}
      />
    ),
    String: () => (
      <DiffViewer
        after="Hello, world! This is a string."
        before="Hello world!"
        className="h-7/10 w-2/3"
        height={240}
      />
    )
  },

  defaultVariant: 'State'
} as const satisfies StoryDeclaration;
